'use strict';

var _ = require('lodash');
var perfectScrollbar = require('perfect-scrollbar');
var PerfectScrollbarDirective = function PerfectScrollbarDirective($parse, $window) {
  var psOptions = ['wheelSpeed', 'wheelPropagation', 'minScrollbarLength', 'useBothWheelAxes', 'useKeyboard', 'suppressScrollX', 'suppressScrollY', 'scrollXMarginOffset', 'scrollYMarginOffset', 'includePadding'];
  return {
    restrict: 'A',
    scope: false,
    link: function link(scope, element, attr) {
      var options = {};
      var container = element.get(0);
      var update = _.throttle(function () {
        if (container) {
          perfectScrollbar.update(container);
        }
      }, 100);
      psOptions.forEach(function (option) {
        if (attr[option] !== undefined) {
          options[option] = $parse(attr[option])();
        }
      });
      perfectScrollbar.initialize(container, options);
      $window.addEventListener('resize', update);
      scope.$on('$destroy', function () {
        if (container) {
          perfectScrollbar.destroy(container);
          container = null;
        }
        $window.removeEventListener('resize', update);
      });
      scope.$on('perfect-scrollbar:update', update);
    }
  };
};
PerfectScrollbarDirective.$inject = ['$parse', '$window'];
module.exports = PerfectScrollbarDirective;